import { accessRole } from '../../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Input, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvField, AvInput, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"
import Shimmer from 'react-shimmer-effect'

import apiResponse from '../../../../../services/apiResponse'

import IndexBloc from '../Index/Blocs/IndexBloc'
import CreateBloc from '../Create/Blocs/CreateBloc'

class IndexView extends Component {

    timer
    indexBloc = new IndexBloc();
    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {}
        }
    }

    submitData = async () => {
        await this.createBloc.fetchUpdate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values,
              user_uuid: this.props.uuid,
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.indexBloc.fetchDetail({ uuid: this.props.uuid })

        this.createBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })       

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break
                default:
                    break
            }
        })       
    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/ref_mesin_absen_user_info.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail User Info</CardTitle>
                            <hr />
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                                <Row className="mb-3">
                                    <label
                                        htmlFor="name"
                                        className="col-md-3 col-form-label"
                                    >
                                        Nama Pegawai <span className="text-danger">*</span>
                                    </label>
                                    <Col md="3">
                                        { detail ? 
                                            <AvField
                                                name="name"
                                                placeholder="Nama Pegawai..."
                                                type="text"
                                                errorMessage="Masukkan Nama Pegawai"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="badgenumber"
                                                value={detail?.name}
                                            />
                                         :
                                            <Shimmer>
                                                <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                            marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="badgenumber"
                                        className="col-md-3 col-form-label"
                                    >
                                        Badge Number <span className="text-danger">*</span>
                                    </label>
                                    <Col md="3">
                                    { detail ? 
                                        <AvField
                                            name="badgenumber"
                                            placeholder="Badge Number..."
                                            type="number"
                                            errorMessage="Masukkan Badge Number"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                            id="badgenumber"
                                            value={detail?.badgenumber}
                                        />
                                        :
                                        <Shimmer>
                                            <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                        marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                        </Shimmer>
                                    }
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md="3"></Col>
                                    <Col md="9">
                                        <Link to="?">
                                            <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                        </Link>
                                        {' '}
                                        <Button color="success" type="submit">
                                            <i className="uil-arrow-up-right"></i> Simpan Data
                                        </Button>
                                    </Col>
                                </Row>
                            </AvForm>
                        </CardBody>
                    </Card>

                </Container>
                 <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/ref_mesin_absen_user_info.html?'/>
                : null }              
            </Fragment>
        )
    }

}

export default IndexView